import { connect } from 'react-redux';
import PushNotificationPreview from '../components/PushNotificationPreview';
import { getCampaignSubject, getCampaignBody } from '../selectors';

const PushNotificationPreviewContainer = connect(
  state => ({
    sendSms: state.engagement.campaign.sendSms,
    sendPush: state.engagement.campaign.sendPush,
    subject: getCampaignSubject(state),
    text: getCampaignBody(state),
  }),
  null,
)(PushNotificationPreview);

export default PushNotificationPreviewContainer;
